import classnames from 'classnames';
import { createElement } from 'react';
import ListItem from './list/ListItem';
import RadioSelf from './Radio';
RadioItem.defaultProps = {
    prefixCls: 'im-radio',
    listPrefixCls: 'im-list',
    radioProps: {},
    labelType: 'start',
    hideBottomLine: true,
    newStyle: false,
    disable: false,
};
function RadioItem(props) {
    const { listPrefixCls, disabled, radioProps, labelType, type, checked, row, cardRow, hideBottomLine, lineStyle, onClick, onChange, newStyle, disable, extra, ...otherProps } = props;
    const { prefixCls, className, children } = otherProps;
    const wrapCls = classnames(className, {
        [`${prefixCls}-item-origin`]: !newStyle && !extra,
        [`${prefixCls}-item-origin`]: !newStyle && extra && row,
        [`${prefixCls}-item-origin-extra`]: !newStyle && extra,
        [`${prefixCls}-item-disabled`]: disabled === true,
        [`${prefixCls}-botderBottom`]: !hideBottomLine && !newStyle,
        [`${prefixCls}-item-new`]: (type == 'card' || newStyle) && !checked && !disabled,
        [`${prefixCls}-item-new-checked`]: (type == 'card' || newStyle) && checked && !disabled,
        [`${prefixCls}-item-new-checked-disable`]: (type == 'card' || newStyle) && checked && disabled,
        [`${prefixCls}-item-new-unchecked-disable`]: (type == 'card' || newStyle) && !checked && disabled,
        [`${prefixCls}-item-new-card`]: type == 'card',
        [`${prefixCls}-item-new-card-row`]: type == 'card' && cardRow,
        [`${prefixCls}-item-new-card-unrow`]: type == 'card' && !cardRow,
    });
    const redTickCls = classnames(className, {
        [`${prefixCls}-checked-right`]: !newStyle,
        [`${prefixCls}-checked-new`]: newStyle,
        [`${prefixCls}-checked-redTick`]: checked && !newStyle,
        [`${prefixCls}-checked-Tick`]: checked && newStyle && !disabled,
        [`${prefixCls}-unChecked-Tick`]: !checked && newStyle && !disabled,
        [`${prefixCls}-unChecked-disable`]: !checked && newStyle && disabled,
        [`${prefixCls}-Checked-disable`]: checked && newStyle && disabled,
    });
    function noop() { }
    if (!disabled) {
        otherProps.onClick = onClick || noop;
    }
    const extraProps = {};
    [
        'name',
        'defaultChecked',
        'checked',
        'onChange',
        'disabled',
        'radioType',
    ].forEach(i => {
        if (i in props) {
            extraProps[i] = props[i];
        }
    });
    return (createElement(ListItem, Object.assign({ line: !newStyle, style: { ...lineStyle }, thumb: labelType === 'start' ? (createElement(React.Fragment, null,
            checked ? createElement("div", { tabIndex: 0, style: {
                    position: 'absolute',
                    width: '16px',
                    height: '16px',
                    display: 'inline-block',
                    top: '50%',
                    marginTop: '-8px',
                    zIndex: 2,
                    opacity: 0
                } },
                checked ? disabled ? '已选中已停用' : '已选中' : disabled ? '未选中已停用' : '未选中',
                "\u5355\u9009\u6309\u94AE")
                : null,
            createElement(RadioSelf, Object.assign({}, radioProps, extraProps, { "aria-hidded": checked, tabIndex: checked ? -1 : 0, type: checked ? '' : 'radio' })))) : null, prefixCls: listPrefixCls, className: wrapCls, hideBottomLine: hideBottomLine, extra: labelType === 'end' && createElement("div", { className: redTickCls }) }, otherProps), children));
}
export default RadioItem;
